import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OktaAuthService } from '../app.service';
import { constants } from '../shared/constants';
import { Activity } from '../shared/model/activity';
import { SupportCaseSearchCriteria } from '../shared/model/searchCriteria';
import { Signal } from '../shared/model/signal';
import { ActivityService } from '../shared/services/activity.service';
import { ErrorService } from '../shared/services/error.service';
import { ItsmService } from '../shared/services/itsm.service';
import { Utilities } from '../shared/utilities';
import * as Highcharts from 'highcharts';
import { faGlasses } from '@fortawesome/free-solid-svg-icons';
import highcharts3D from 'highcharts/highcharts-3d';
highcharts3D(Highcharts);

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  perPage = constants.recordsPerPage.activity;
  currentPage: number;

  userObject: any;
  sinceLastLogin: Activity[];

  //activities
  activities: Activity[];
  subsetActivities: Activity[];
  loadedActivities: boolean;

  //case stats
  last30dayCreated: number;
  last30dayClosed: number;
  newHighPriority: number;
  newCriticalPriority: number;
  openCases: number;
  customerPending: number;
  loadedCaseStats: boolean;

  latestSignals: Signal[];
  loadedSignals: boolean;

  globalPriority1: number;
  globalPriority2: number;
  globalPriority3: number;
  globalPriority4: number;

  Highcharts: typeof Highcharts = Highcharts;
  chartDataLoaded: boolean;
  annualChartDataLoaded: boolean;

  updateCategoryPie: boolean;
  catPieChartOptions :any ;
  loadedOpenCases: boolean;



  constructor(
    private activitySearch: ActivityService,
    private auth: OktaAuthService,
    private errorService: ErrorService,
    private itsmService: ItsmService,
    private translate: TranslateService) {
  }

  ngOnInit() {
    this.currentPage = 1;
    this.loadedActivities = false;
    this.loadedCaseStats = false;
    this.loadedSignals = false;
    this.loadedOpenCases = false;

    

    this.auth.getUserDetails().then(val => {
      this.userObject = val;
    });

    // load sigs and vulns since user last logged in
    this.activitySearch.loadSinceLastVisit()
      .then(res => {
        this.sinceLastLogin = res;
      })
      .catch(err => {
        this.errorService.handlerError(err);
      });

    // load the latest activity and save the latest signals in session storage
    // for use in the signals list
    this.activitySearch.loadActivityDays(7, true)
      .then(res => {
        this.activities = res.slice(0, 30);
        this.subsetActivities = this.activities.slice(this.perPage*(this.currentPage-1), this.perPage);
        this.loadedActivities = true;
        this.latestSignals = JSON.parse(sessionStorage.getItem("latestSignals"));
        this.loadedSignals = true;
      })
      .catch(err => {
        delete this.activities;
        delete this.subsetActivities;
        this.loadedActivities = true;
        delete this.latestSignals;
        this.loadedSignals = true;
        this.errorService.handlerError(err);
      });

    // load ticket statistics
    // created 30 days
    // closed 30 days
    // open and high priority
    let created30Criteria = new SupportCaseSearchCriteria();
    created30Criteria.createdFrom = Utilities.getTodayMinusDays(30);
    created30Criteria.createdTo = Utilities.getToday();
    created30Criteria.count = true;

    let closed30Criteria = new SupportCaseSearchCriteria();
    closed30Criteria.closedDateFrom = Utilities.getTodayMinusDays(30);
    closed30Criteria.closedDateTo = Utilities.getToday();
    closed30Criteria.count = true;

    let pendingCustomerCriteria = new SupportCaseSearchCriteria();
    pendingCustomerCriteria.status = constants.itsm.pendingCustomer;
    pendingCustomerCriteria.count = true;

    let openHighCriteria = new SupportCaseSearchCriteria();
    openHighCriteria.createdFrom = Utilities.getTodayMinusDays(30);
    openHighCriteria.createdTo = Utilities.getToday();
    openHighCriteria.status = constants.itsm.open;
    openHighCriteria.priority = constants.itsm.high;
    openHighCriteria.count = true;

    let criticalHighCriteria = new SupportCaseSearchCriteria();
    criticalHighCriteria.createdFrom = Utilities.getTodayMinusDays(30);
    criticalHighCriteria.createdTo = Utilities.getToday();
    criticalHighCriteria.status = constants.itsm.open;
    criticalHighCriteria.priority = constants.itsm.critical;
    criticalHighCriteria.count = true;

    Promise.allSettled([
      // this.itsmService.caseSearch(created30Criteria),
      // this.itsmService.caseSearch(closed30Criteria),
      // this.itsmService.caseSearch(openHighCriteria),
      // this.itsmService.caseSearch(criticalHighCriteria),
      this.itsmService.caseSearch(pendingCustomerCriteria),
    ])
    .then(res => {
      // if(res[0].status === 'fulfilled'){
      //   this.last30dayCreated = res[0].value;
      // }else{
      //   delete this.last30dayCreated;
      // }
      // if(res[1].status === 'fulfilled'){
      //   this.last30dayClosed = res[1].value;
      // }else{
      //   delete this.last30dayClosed;
      // }
      // if(res[2].status === 'fulfilled'){
      //   this.newHighPriority = res[2].value;
      // }else{
      //   delete this.newHighPriority;
      // }
      // if(res[3].status === 'fulfilled'){
      //   this.newCriticalPriority = res[3].value;
      // }else{
      //   delete this.newCriticalPriority;
      // }
      if(res[0].status === 'fulfilled'){
        this.customerPending = res[0].value;
      }else{
        delete this.customerPending;
      }
      this.loadedCaseStats = true;
    })
    .catch(err => {
      this.loadedCaseStats = true;
      this.errorService.handlerError(err);
    })

    this.getOpenedCases();
  }

  pageActivity(event: any): void {
    this.subsetActivities = this.activities.slice(this.perPage*(this.currentPage-1), (this.perPage*(this.currentPage-1)) + this.perPage);
  }

  getOpenedCases(){
    let globalCriteria = new SupportCaseSearchCriteria();
    globalCriteria.status = constants.itsm.open;

    this.itsmService.caseSearch(globalCriteria).then(res => {

      this.openCases = res.length;

      this.globalPriority1 = res.filter(a => a["priority"] == "1 - Business Critical").length;
      this.globalPriority2 = res.filter(a => a["priority"] == "2 - High").length;
      this.globalPriority3 = res.filter(a => a["priority"] == "3 - Medium").length;
      this.globalPriority4 = res.filter(a => a["priority"] == "4 - Low").length;

      this.drawPriorityTable();
      this.loadedOpenCases = true;
    }).catch(err => {
      this.loadedCaseStats = true;
      this.loadedOpenCases = false;
      this.errorService.handlerError(err);
    });
  }

  drawPriorityTable(){
    this.catPieChartOptions = {
      chart: {
        type: 'pie',
        options3d: {
          enabled: true,
          alpha: 45,
          beta: 0
       }
      },
      credits: {
        enabled : false
      },
      legend: {
        enabled : false
      },
      title: {
          text: 'Open Case Priorities'
      },
      tooltip : {
          pointFormat: '<b>{point.percentage:.1f}%</b>'
      },
      plotOptions : {
        pie: {
          innerSize: 100,
          depth: 45,
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b><br>{point.y}'
          }
       }
      },
      series: [
        {
          name: 'Open Case',
          zMin: 0,
          data: [
            { y: this.globalPriority1, z: 300, color: '#E75B60', name: 'Business Critical', selected: true, sliced: true},
            { y: this.globalPriority2, z: 250, color: '#FF7900', name: 'High'},
            { y: this.globalPriority3, z: 200, color: '#FFD200', name: 'Medium'},
            { y: this.globalPriority4, z: 150, color: '#4BB4E6', name: 'Low'}
          ]
        }
      ]
    };
  }

}
